import { Hidden } from '@patrianna/core-components'
import { getCookie } from '@patrianna/shared-utils'
import { useRouter, useSearchParams } from 'next/navigation'

import Registration from 'containers/Auth/Registration'
import BackButton from 'src/components/BackButton'
import AuthDialogLayout from 'src/containers/Auth/AuthDialogLayout'
import AuthContent from 'src/containers/AuthContent'
import RegisterButtons from 'src/containers/RegisterButtons'

import classes from './styles.module.scss'

function RegisterPage({ cookie }: { cookie: string }) {
  const router = useRouter()
  const searchParams = useSearchParams()

  const isFBAudience = searchParams.get('utm_source') === 'facebook' || getCookie('utm_source', cookie) === 'facebook'

  return (
    <AuthDialogLayout dataTest='register-page'>
      {searchParams.get('auth_type') === `${'REGISTRATION'}_MANUAL` ? (
        <>
          <Hidden visibleFor='mobile'>
            <BackButton className={classes.button} handler={router.back} />
          </Hidden>
          <Registration />
        </>
      ) : (
        <AuthContent>
          <RegisterButtons isFBAudience={isFBAudience} />
        </AuthContent>
      )}
    </AuthDialogLayout>
  )
}

export default RegisterPage
